// DeleteConfirmationModal.styled.jsx
import { styled } from "@mui/material/styles";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
export const StyledModal = styled(Modal)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backdropFilter: "blur(4px)",
  backgroundColor: "rgba(0, 0, 0, 0.3)",
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  background: "white",
  padding: "30px",
  borderRadius: "12px",
  textAlign: "center",
  maxWidth: "300px",
  width: "90%",
  boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
  position: "relative",

  ".icon-wrapper": {
    backgroundColor: "#fff",
    color: "red",
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    margin: "-70px auto 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    "& svg": {
      fontSize: "40px",
    },
  },

  ".title": {
    fontWeight: "bold",
    fontSize: "20px",
    marginBottom: "5px",
  },

  ".sub-text": {
    color: "#888",
    fontSize: "16px",
    marginBottom: "25px",
  },

  ".button-group": {
    display: "flex",
    justifyContent: "center",
  },

  ".delete-button": {
    backgroundColor: "red",
    color: "white",
    border: "none",
    padding: "5px 10px",
    borderRadius: "6px",
    fontSize: "14px",
    cursor: "pointer",
    boxShadow: "0px 2px 4px rgba(255, 0, 0, 0.3)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translate(2px, -2px)",
    },
  },

  ".cancel-button": {
    backgroundColor: "white",
    color: "#333",
    border: "1px solid #ccc",
    padding: "10px 10px",
    borderRadius: "6px",
    cursor: "pointer",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translate(2px, -2px)",
    },
  },
}));